/**
 * Portal boot. Builds the live Firebase-backed services, wraps the app in the
 * ServicesProvider + BrowserRouter, and mounts. The router `basename` is '/' —
 * the portal owns the hosting root (native games live under `/games/<slug>/` as
 * separate builds the portal only links to).
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ServicesProvider } from './services/context.js';
import { createFirebaseServices } from './services/firebase.js';
import './styles.css';

if (!globalThis.__DJGG_CANONICAL_REDIRECT__) {
  const services = createFirebaseServices();
  const root = document.getElementById('root');
  if (!root) throw new Error('missing #root');

  createRoot(root).render(
    <StrictMode>
      <ServicesProvider services={services}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ServicesProvider>
    </StrictMode>,
  );
}
